import { Component, Input } from '@angular/core';
import { ButtonComponent } from 'components/input/button/button.component';
import { IconComponent, IconType } from 'components/layout/icon/icon.component';
import { StorageContainerType } from 'constants/StorageContainer';
import { FileStorageService } from 'services/file-storage.service';

@Component({
	selector: 'file-download',
	template: '<button small [ignoreValidation]="true" [active]="fileName && container ? true : false" [loader]="false" (click)="downloadFile()">@if (icon) {<icon [type]="icon"></icon>}{{ name }}</button><ng-content></ng-content>',
	styles: [':host { display: inline-flex; gap: 10px; align-items: center; }'],
	imports: [ButtonComponent, IconComponent]
})
export class FileDownloadComponent {

	private _fileName?: string;

	name?: string;

	@Input() container?: StorageContainerType;
	@Input() icon?: IconType
	@Input() set fileName(value: string | undefined) {
		if (!value) {
			this.name = undefined;
			return;
		}
		if (value == this._fileName) return;

		this._fileName = value;
		this.name = this.fileStorageService.getFileName(value);
	}
	get fileName() { return this._fileName };

	downloadFile() {
		if (!this.fileName || !this.container) return;
		this.fileStorageService.downloadFile(this.fileName, this.container);
	}

	constructor(public fileStorageService: FileStorageService) { }
}

